/* eslint-disable */
import React, { useState } from 'react';
import { styled } from '@mui/system';

import Dialog from '@mui/material/Dialog';
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { Config } from '../config/config';
import Cookie from 'js-cookie';
import axios from 'axios';
import Spinner from '../UIComponents/Spinner/Spinner';
import { ThemeProvider, createTheme } from '@mui/material/styles'; 

const theme = createTheme();



const CustomDialogTitle = styled(DialogTitle)(({ theme }) => ({
  fontSize: "16px",
  maxWidth: "864px",
  background: "#3c8dbc",
  color: "#fff",
}));
const CustomDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: "#eaf7fdcc",
}));
const ViewInvoice = (props) => {
  const [open, setOpen] = React.useState(props.invoiceOpen);
  const [fullWidth] = React.useState(true);
  const [loading, setLoading] = React.useState(false);
  const [maxWidth] = React.useState('sm');

  const [invoiceData] = useState(props.invoiceData);

  let cav = [];

  const handleClose = () => {
    setOpen(false);
    props.setInvoiceViewer(false);
  };

  const config = JSON.parse(Config);
  const fileDownload = (documentPath) => {
    setLoading(true);
    let headers = {
      Authorization: 'Bearer ' + JSON.parse(Cookie.get('token')),
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/octet-stream',
      'x-api-key': process.env.REACT_APP_X_API_KEY,
    };
    axios
      .get(
        process.env.REACT_APP_UPLOAD_DOWNLOAD +
          config['api'] +
          '/download?objectId=' +
          documentPath,
        {
          headers: headers,
          responseType: 'blob',
        }
      )
      .then((response) => {
        //Create a Blob from the PDF Stream
        // alert(JSON.stringify(response.data));
        var re = /(?:\.([^.]+))?$/;

        var ext = re.exec(documentPath)[1]; // "txt"
        const MimeTypesMap = {
          png: 'image/png',
          PNG: 'image/PNG',
          gif: 'image/gif',
          GIF: 'image/GIF',
          jpg: 'image/jpg',
          JPG: 'image/JPG',
          jpeg: 'image/jpeg',
          JPEG: 'image/JPEG',
          pdf: 'application/pdf',
          mp4: 'video/mp4',
          doc: 'application/msword',
          docx:
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          ppt: 'application/vnd.ms-powerpoint',
          pptx: 'application/vnd.ms-powerpoint',
          xlsx:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        };

        const mimeType = MimeTypesMap[ext];
        const file = new Blob([response.data], { type: mimeType });
        //Build a URL from the file
        const fileURL = URL.createObjectURL(file);
        //Open the URL on new Window

        if (mimeType === 'application/pdf') {
          window.open(fileURL, '_blank');
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', documentPath); //or any other extension
          document.body.appendChild(link);
          link.click();
        }
        setLoading(false);
      })
      .catch((error) => {});
  };
  {
    cav = invoiceData.map((ins) => {
      return (
        <tr>
          <td
            onClick={() => fileDownload(ins.invoicePdf)}
            style={{ cursor: 'pointer' }}
          >
            {ins.invoiceNumber}
          </td>
          <td
            onClick={() => fileDownload(ins.invoicePdf)}
            style={{ cursor: 'pointer' }}
          >
            {ins.invoicePdf}
          </td>
          <td>{ins.invoiceUploadedDate}</td>
        </tr>
      );
    });
  }

  return (
    <ThemeProvider theme={theme}>
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby='customized-dialog-title'
        open={open}
        fullWidth={fullWidth}
        maxWidth={maxWidth}
      >
       <CustomDialogTitle onClose={handleClose}>
          <p style={{ fontSize: '1.5em' }}>View Invoice</p>
        </CustomDialogTitle>

        <CustomDialogContent dividers>
          <form
            className='form-horizontal '
            style={{ backgroundColor: '#eaf7fdcc' }}
            onSubmit={(event) => {
              event.preventDefault();

              setOpen(false);
            }}
          >
            <div className='form-group'>
              {loading ? (
                <Spinner />
              ) : (
                <div className='col-md-12'>
                  <table
                    style={{ minWidth: '100%', fontSize: '1.7vh' }}
                    className='table table-bordered table-striped mainGrid col-md-12'
                    id='DataGrid'
                  >
                    <thead
                      style={{
                        background: 'rgb(60, 141, 188)',
                        color: '#fff',
                      }}
                    >
                      <tr>
                        <th>Invoice Number</th>
                        <th>Invoice Name</th>
                        <th>Uploaded Date</th>
                      </tr>
                    </thead>
                    <tbody
                      style={{
                        color: 'black',
                      }}
                    >
                      {invoiceData.length > 0 ? (
                        cav
                      ) : (
                        <tr>
                          <td colSpan={3} className='text-center'>
                            No invoice available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </form>
        </CustomDialogContent>
      </Dialog>
    </div>
    </ThemeProvider>
  );
};
export default ViewInvoice;
